module.exports = __webpack_public_path__ + "static/media/5.d1c8ad84.jpg";